import {
  generalTerm,
} from '@/constants/locales/sk.shared.ts';

export default {
  tabMenu: {
    view: 'Rozmiestnenie',
    alarm: 'Alarmy',
    loadList: 'Zoznam vsázok',
    recipe: generalTerm.recipe,
  },
};
